const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHANGE_FINANCIAL_CULTURE
} = require('constants/actionTypes.js');

const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP2_CONTINUE_WITH_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHECK_INCOHERENCES
} = require('mifid/constants/actionTypes');

const changeFinancialCulture = (financialCulture) => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHANGE_FINANCIAL_CULTURE,
        payload: {
            financialCulture
        }
    });
}

const checkIncoherences = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHECK_INCOHERENCES
    });
}

const continueWithIncoherences = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP2_CONTINUE_WITH_INCOHERENCES
    })
}

module.exports = {
    changeFinancialCulture,
    checkIncoherences,
    continueWithIncoherences
};
